import type { GradeMappingSchema } from '@repo/schemas/grade-scale/gradeScale';

import { cn } from '@repo/lib/cn';
import { ChevronDownIcon, PlusIcon, XIcon } from 'lucide-react';
import { useState } from 'react';

import { Badge } from '@/components/ui/badge';

import { GradeMappingDialog } from './GradeMappingDialog';
import { GradeMappingPreview } from './GradeMappingPreview';
import { GradeScaleOptionsMenu } from './GradeScaleOptionsMenu';

export interface GradeScaleFieldProps {
  gradeMapping: GradeMappingSchema | null | undefined;
  onChange: (gradeMapping: GradeMappingSchema | null) => void;
  headingClassName?: string;
  className?: string;
}

/** "Skala ocen" section: add/remove badge plus a preview that opens the editor. */
export function GradeScaleField(gradeScaleFieldProps: GradeScaleFieldProps) {
  const { gradeMapping, onChange, headingClassName, className } = gradeScaleFieldProps;
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const mapping: GradeMappingSchema | null = gradeMapping ?? null;

  return (
    <div className={cn('space-y-3', className)}>
      <div className="flex items-center justify-between gap-2">
        <h5 className={cn('text-base font-semibold', headingClassName)}>Skala ocen</h5>
        {mapping ? (
          <Badge variant="muted" border onClick={() => onChange(null)} className="cursor-pointer">
            <XIcon />
            Usuń
          </Badge>
        ) : (
          <GradeScaleOptionsMenu currentGradeMapping={null} removeDisabled onSelectPreset={(next) => onChange(next)} onSelectCustom={(next) => onChange(next)}>
            <Badge asChild variant="muted" border className="group cursor-pointer">
              <button type="button">
                <PlusIcon />
                Dodaj skalę
                <ChevronDownIcon className="transition-transform duration-200 group-data-[state=open]:rotate-180" />
              </button>
            </Badge>
          </GradeScaleOptionsMenu>
        )}
      </div>
      <button
        type="button"
        onClick={() => setDialogOpen(true)}
        aria-label="Edytuj skalę ocen"
        className="outline-focus-ring-primary block w-full cursor-pointer rounded-md text-left outline-0 focus-visible:outline-3"
      >
        <GradeMappingPreview gradeMapping={mapping} />
      </button>
      <GradeMappingDialog
        open={dialogOpen}
        onOpenChange={setDialogOpen}
        initialGradeMapping={mapping}
        onConfirm={(next) => {
          setDialogOpen(false);
          onChange(next);
        }}
      />
    </div>
  );
}
